import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/customerService/attarctCustorme';
import chooseHouseTree from './chooseHouseTree';
import { fetchListByType } from '@/api/PMS/dic/dic';
export default {
  components: {
    chooseHouseTree: chooseHouseTree
  },
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      title: '',
      dialogFormVisible: false,
      lossStatusOption: [],
      businessOption: [],
      customStatusOption: [],
      saleStatusOption: [],
      sourceStatusOption: [],
      childData: {},
      rules: {
        attractName: [{
          required: true,
          message: '请输入客户名称',
          trigger: 'blur'
        }],
        industry: [{
          required: true,
          message: '请选择所属行业',
          trigger: 'change'
        }],
        attractStatus: [{
          required: true,
          message: '请选择客户状态',
          trigger: 'change'
        }],
        loseDate: [{
          required: true,
          message: '请选择流失时间',
          trigger: 'change'
        }],
        loseReason: [{
          required: true,
          message: '请选择流失原因',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.init();
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs['dataForm'].resetFields();

        if (this.showDialog) {
          this.init();
        }
      }
    }
  },
  methods: {
    loadBusinessOption: function loadBusinessOption() {
      var _this = this;

      fetchListByType('industry').then(function (r) {
        _this.businessOption = r.data.data;
      });
    },
    loadLossStatusOption: function loadLossStatusOption() {
      var _this2 = this;

      fetchListByType('lose_reason').then(function (r) {
        _this2.lossStatusOption = r.data.data;
      });
    },
    loadCustomStatusOption: function loadCustomStatusOption() {
      var _this3 = this;

      fetchListByType('attract_status').then(function (r) {
        _this3.customStatusOption = r.data.data;
      });
    },
    loadsourceStatusOption: function loadsourceStatusOption() {
      var _this4 = this;

      fetchListByType('channel_type').then(function (r) {
        _this4.sourceStatusOption = r.data.data;
      });
    },
    loadSaleStatusOption: function loadSaleStatusOption() {
      var _this5 = this;

      fetchListByType('sales_status').then(function (r) {
        _this5.saleStatusOption = r.data.data;
      });
    },
    init: function init() {
      this.loadBusinessOption();
      this.loadLossStatusOption();
      this.loadCustomStatusOption();
      this.loadsourceStatusOption();
      this.loadSaleStatusOption();
      this.loadData();
    },
    loadData: function loadData() {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          attractId: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this6.childData = response.data.data;
          _this6.childData.attractStatus = _this6.childData.attractStatus.toString();
          _this6.childData.industry = _this6.childData.industry.toString();
          _this6.childData.channelType = _this6.childData.channelType.toString();
          _this6.childData.salesStatus = _this6.childData.salesStatus.toString();
          _this6.childData.loseReason = _this6.childData.loseReason.toString();
        });
      } else {
        this.childData = {
          detailList: null
        };
      }
    },
    handCreate: function handCreate() {
      var _this7 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var houseList = [];

          if (_this7.childData.detailList !== null && _this7.childData.detailList.length > 0) {
            _this7.childData.detailList.forEach(function (element) {
              detailList.push({
                houseId: element.houseId
              });
            });
          }

          _this7.childData.houseList = houseList;

          if (_this7.keyValue > 0) {
            fetchUpdate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this7.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    },
    addHouse: function addHouse() {
      this.title = '请选择房产信息';
      this.dialogFormVisible = true;
    },
    handhouseCancle: function handhouseCancle() {
      this.dialogFormVisible = false;
    },
    receiveHouseData: function receiveHouseData(data) {
      console.log(data);
    },
    handleDelete: function handleDelete(id) {
      var _this8 = this;

      this.$confirm('你确定是要删除, 是否继续?', '提示').then(function () {
        _this8.childData.detailList.forEach(function (element, index) {
          if (element.houseId === id) {
            _this8.childData.detailList.splice(index, 1);
          }
        });

        _this8.Alert({
          alertType: 'delete'
        });
      });
    }
  }
};